import React from 'react';
import TimeAgo from 'react-timeago';
import Post from '../Timeline/Post'; // Reuse existing Post component

const MessageBubble = ({ message, currentUser, showAvatar, onRetryMessage }) => {
  const isOwnMessage = message.user.username === currentUser.username;
  const isCommand = message.is_command;
  const isPending = message.isPending;
  const isConfirmed = message.isConfirmed;
  const isFailed = message.isFailed;
  
  // Handle different message types
  const renderMessageContent = () => {
    // If message contains a shared post
    if (message.post) {
      return (
        <div className="shared-post-container">
          <div className="shared-post-label">
            <span>📄 Post compartilhado</span>
          </div>
          <div className="shared-post-content">
            <Post 
              post={message.post} 
              user={currentUser}
              isShared={true}
              compact={true}
            />
          </div>
        </div>
      );
    }
    
    // Command messages (system messages)
    if (isCommand) {
      return (
        <div className="command-message">
          <em>{message.body}</em>
        </div>
      );
    }
    
    // Regular text message
    return (
      <div className="text-message">
        {message.body}
      </div>
    );
  };

  const getUserRole = () => {
    if (message.conversation_user?.conversation_role) {
      const roleName = message.conversation_user.conversation_role.name;
      if (roleName.includes('Admin')) {
        return roleName;
      }
    }
    return null;
  };

  const getMessageStatus = () => {
    if (!isOwnMessage) return null;
    
    if (isFailed) {
      return (
        <span 
          className="message-status failed" 
          title="Clique para tentar novamente"
          onClick={() => onRetryMessage && onRetryMessage(message)}
        >
          🔄
        </span>
      );
    }
    
    if (isPending && !isConfirmed) {
      return <span className="message-status pending" title="Enviando...">⏳</span>;
    }
    
    if (isConfirmed || (!isPending && !isFailed)) {
      return <span className="message-status confirmed" title="Enviado">✓</span>;
    }
    
    return null;
  };

  const userRole = getUserRole();

  // Command messages are centered and styled differently
  if (isCommand) {
    return (
      <div className="message-bubble command-message-bubble">
        <div className="command-content">
          {renderMessageContent()}
          <div className="message-time">
            <TimeAgo date={message.created_at} />
          </div>
        </div>
      </div>
    );
  }

  // Determine message bubble classes
  const bubbleClasses = [
    'message-bubble',
    isOwnMessage ? 'own-message' : 'other-message',
    isPending && !isConfirmed ? 'pending-message' : '',
    isFailed ? 'failed-message' : '',
    isConfirmed ? 'confirmed-message' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={bubbleClasses}>
      <div className="message-content">
        {showAvatar && !isOwnMessage && (
          <div className="message-avatar">
            <img 
              src={message.user.avatar || '/images/default-avatar.png'} 
              alt={message.user.username}
              title={message.user.username}
            />
          </div>
        )}
        
        <div className="message-body">
          {showAvatar && !isOwnMessage && (
            <div className="message-header">
              <span className="message-username">
                {message.user.username}
                {userRole && (
                  <span className={`user-role ${userRole.toLowerCase().replace('admin', 'admin')}`}>
                    ({userRole})
                  </span>
                )}
              </span>
            </div>
          )}
          
          <div className={`message-text ${userRole?.includes('Admin') ? 'admin-message' : ''}`}>
            {renderMessageContent()}
          </div>
          
          <div className="message-time">
            <TimeAgo date={message.created_at} />
            {getMessageStatus()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
